import {
    IExponeaSDK,
    TExponeaSdkNotificationsSubscribeStatus,
    TExponeaSdkNotificationsUnsubscribeStatus
} from "./exponea.t";

class ExponeaNotifications {
    private exponea: IExponeaSDK;

    constructor(exponeaSdk = window.exponea) {
        this.exponea = exponeaSdk;
    }

    isAvailable = (): Promise<boolean> => {
        return new Promise((resolve) => {
            this.exponea.notifications.isAvailable((available) => {
                resolve(available);
            })
        });
    }

    isSubscribed = (): Promise<{ active: boolean, denied: boolean }> => {
        return new Promise((resolve) => {
            this.exponea.notifications.isSubscribed((active, denied) => {
                resolve({ active, denied });
            });
        });
    }

    subscribe = (): Promise<TExponeaSdkNotificationsSubscribeStatus> => {
        return new Promise((resolve) => {
            this.exponea.notifications.subscribe((status) => {
                resolve(status);
            }, { web_push_notifications: true });
        });
    }

    unsubscribe = (): Promise<TExponeaSdkNotificationsUnsubscribeStatus> => {
        return new Promise((resolve) => {
            this.exponea.notifications.unsubscribe((status) => {
                resolve(status);
            });
        });
    }
}

export default ExponeaNotifications
